import { globalEntitlements } from './globalEntitlements';

// Service name constants
const BASIC = 's_corp_basic_bundle_v1';
const ESSENTIAL = 's_corp_essential_bundle_v1';
const PREMIUM = 's_corp_premium_bundle_v1';

/**
 * Gets the appropriate S Corp Bundle buy button configuration using globalEntitlements builder
 * @param {...any} args
 * @returns {object} - Buy button configuration object
 */
export const getSCorpBundleBuyButtonConfig = (...args) => {
  const [, serviceCode] = args;
  const serviceToButtonText = {
    [BASIC]: 'productPage.sCorpBundle.buyBox.buttonLabel1',
    [ESSENTIAL]: 'productPage.sCorpBundle.buyBox.buttonLabel2',
    [PREMIUM]: 'productPage.sCorpBundle.buyBox.buttonLabel3'
  };

  const ctaText = serviceToButtonText[serviceCode] || serviceToButtonText[BASIC];

  const blockingRules = {
    [BASIC]: [BASIC, ESSENTIAL, PREMIUM],
    [ESSENTIAL]: [ESSENTIAL, PREMIUM],
    [PREMIUM]: [ESSENTIAL, PREMIUM]
  };

  const builder = globalEntitlements({ ctaText })
    .blockedByRelatedServices(blockingRules[serviceCode] || []);

  return builder.build()(...args);
};
